import { CommonModule } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { DataTableFilterMessageService } from '../../../../../../shared/components/data-table/filters/components/data-table-filter-message-service';
import { BaseDataTableFilter } from '../../../../../../shared/components/data-table/filters/components/data-table-filter/BaseDataTableFilter';
import { VerificationPackagesFilterStateService } from '../../../../services/verification-packages-filter-state.service';
import { VerificationPackagesTableMessageService } from '../../../../services/verification-packages-table-message.service';

@Component({
  selector: 'app-verification-packages-filter-status',
  templateUrl: './verification-packages-filter-status.component.html',
  styleUrls: ['./verification-packages-filter-status.component.scss'],
  standalone: true,
  imports: [
    CommonModule, 
    MatButtonModule, 
    MatRadioModule,
    FormsModule
  ]
})
export class VerificationPackagesFilterStatusComponent extends BaseDataTableFilter implements OnDestroy {

  constructor(
    private filterStateService: VerificationPackagesFilterStateService,
    private filterMessageService: DataTableFilterMessageService,
    private verificationPackagesMessageService: VerificationPackagesTableMessageService
  ) {
    super(filterMessageService);
  }

  ngOnDestroy(): void {
    this.filterStateService.reset();
    this.clearSubscriptions();
  }

  onApplyClicked(): void {    
    const isActive = this.filterStateService.status != 0;

    let statusText;
    if (this.filterStateService.status == 1) {
      statusText = "Active";
    }
    if (this.filterStateService.status == 2) {
      statusText = "Inactive";
    }

    this.verificationPackagesMessageService.applyFilter();
    this.filterMessageService.setActive({ filterId: this.id, active: isActive, value: statusText });
  }

  onClearClicked(): void {
    this.filterStateService.resetStatusFilter();
    this.verificationPackagesMessageService.applyFilter();
    this.filterMessageService.setActive({ filterId: this.id, active: false });
  }

  getStateService(): VerificationPackagesFilterStateService {
    return this.filterStateService;
  }

  openedChange(opened: boolean) {
    const clickoutEnabled = !opened;
    this.filterMessageService.setClickoutEnabled(clickoutEnabled);
  }
}